import React from 'react';
import { Redirect, Switch } from 'react-router-dom';

import HelmetWrapper from 'components/atoms/HelmetWrapper';
import BackOfficeDrawerPusher from 'components/features/backOffice/BackOfficeDrawerPusher';
import BackOfficeNavigation from 'components/features/backOffice/BackOfficeNavigation';
import { ErrorBoundary, SentryRoute as Route } from 'config/sentry';
import CiboSubscriptionListPageContainer from 'containers/_pages/CiboSubscriptionListPageContainer';
import BackOfficeDeviceMap from 'routes/BackOfficeDeviceMap';
import BackOfficeDevices from 'routes/BackOfficeDevices';
import BackOfficeEnterprises from 'routes/BackOfficeEnterprises';
import BackOfficeInvitations from 'routes/BackOfficeInvitations';
import BackOfficeOperations from 'routes/BackOfficeOperations';
import BackOfficeOperationsDataTransfer from 'routes/BackOfficeOperationsDataTransfer';
import BackOfficeUsers from 'routes/BackOfficeUsers';
import { useMyUserHasInternalPermission } from 'store/modules/myUser/hooks';
import { ProtectedResource, ResourceAction } from 'types/action.enum';

function BackOffice(): JSX.Element {
  const canViewEnterpriseUsers = useMyUserHasInternalPermission({
    resource: ProtectedResource.ENTERPRISE_USER,
    action: ResourceAction.READ
  });
  const canViewInternalUsers = useMyUserHasInternalPermission({
    resource: ProtectedResource.INTERNAL_USER,
    action: ResourceAction.READ
  });
  const canAccessBackOfficeUsers = canViewEnterpriseUsers || canViewInternalUsers;
  const canAccessBackOfficeInvitations = useMyUserHasInternalPermission({
    resource: ProtectedResource.INVITATION,
    action: ResourceAction.READ
  });

  return (
    <ErrorBoundary>
      <BackOfficeDrawerPusher>
        <>
          <ErrorBoundary>
            <HelmetWrapper section="Back Office" />
            <BackOfficeNavigation />
          </ErrorBoundary>
          <ErrorBoundary>
            <Switch>
              <Redirect exact from="/back-office" to="/back-office/enterprises" />
              <Route
                exact
                path="/back-office/enterprises/:enterpriseId/cibo-subscriptions"
                component={CiboSubscriptionListPageContainer}
              />
              <Route
                path="/back-office/enterprises"
                component={BackOfficeEnterprises}
              />
              <Route
                path="/back-office/devices"
                component={BackOfficeDevices}
              />
              <Route
                path="/back-office/device-map"
                component={BackOfficeDeviceMap}
              />
              <Route
                path="/back-office/operations/data-transfer"
                component={BackOfficeOperationsDataTransfer}
              />
              <Route
                path="/back-office/operations"
                component={BackOfficeOperations}
              />
              {canAccessBackOfficeUsers && <Route path="/back-office/users" component={BackOfficeUsers} />}
              {canAccessBackOfficeInvitations && (<Route
                path="/back-office/invitations"
                component={BackOfficeInvitations}
              />)}
              <Redirect from="/*" to="/back-office/enterprises" />
            </Switch>
          </ErrorBoundary>
        </>
      </BackOfficeDrawerPusher>
    </ErrorBoundary>
  );
}

export default BackOffice;
